import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  back(e) {
    if (!this.isFirstHistoryEntry) {
      window.history.back();
      e.preventDefault();
    }
  }

  get isFirstHistoryEntry() {
    return (
      !window.history.state.turbo ||
      window.history.state.turbo.restorationIndex === 0
    );
  }
}
